import styled from '@emotion/styled'

import {
  FONT_FAMILY,
  BOX_PAIR_MAX_WIDTH,
  GUTTER_LABEL_MAX_WIDTH,
  GUTTER_GAP,
} from '../../../../components/AdviceSummary/shared'
import { cardBorderColor } from '../../../../components/advice/shared'
import { translucentCardBackground } from '../../../../components/RoundedCard'
import { MOBILE } from '../../../../guided-toolbox/utils/breakpoints'

// Switch to the compact layout below 800px, when gutter labels no longer fit beside the comparison rows.
export const SUMMARY_COMPACT_VIEWPORT = '(max-width: 799px)'
export const SUMMARY_COMPACT = `@media ${SUMMARY_COMPACT_VIEWPORT}`

export const Heading = styled.h1`
  width: 90%;
  max-width: 760px;
  margin: 0 0 30px;
  font-family: ${FONT_FAMILY};
  font-size: 30px;
  font-weight: normal;
  line-height: 1.3;
  text-align: center;
  color: ${p => p.theme.mediumGray};

  ${MOBILE} {
    font-size: 24px;
  }
`

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  row-gap: 40px;
  margin-top: 40px;

  ${SUMMARY_COMPACT} {
    row-gap: 12px;
    margin-top: 24px;
  }
`

// Leaves room for a gutter-label column on each side of the centered box pair.
export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: calc(${BOX_PAIR_MAX_WIDTH}px + 2 * (${GUTTER_LABEL_MAX_WIDTH}px + ${GUTTER_GAP}px));
  row-gap: 16px;
`

export const SectionTitle = styled.h2`
  font-family: ${FONT_FAMILY};
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  margin: 0;
  color: ${p => p.theme.darkestGray};
`

// Matches the comparison box pair so their outer edges align.
export const GoalCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  column-gap: 16px;
  width: 100%;
  max-width: ${BOX_PAIR_MAX_WIDTH}px;
  margin-bottom: 48px;
  padding: 16px 24px;
  border: 2px solid ${cardBorderColor};
  border-radius: 10px;
  background: ${p => p.theme.cardBgColor ?? '#ffffff'};
  ${translucentCardBackground}
  font: inherit;
  text-align: left;

  ${SUMMARY_COMPACT} {
    position: relative;
    margin-bottom: 24px;
    padding: 14px 12px 14px 20px;
    background: #ffffff;
    cursor: pointer;
  }
`

export const GoalCardEditIcon = styled.span`
  position: absolute;
  top: 10px;
  right: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${p => p.theme.lightestGray};
`

export const GoalCardMain = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
  min-width: 0;
`

export const GoalCardText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 4px;
  min-width: 0;
`

export const GoalCardLabel = styled.div`
  font-family: ${FONT_FAMILY};
  font-size: 13px;
  font-weight: 600;
  color: ${p => p.theme.darkestGray};
`

export const GoalCardValue = styled.div`
  font-family: ${FONT_FAMILY};
  font-size: 18px;
  font-weight: 400;
  color: ${p => p.theme.darkestGray};
`

export const GoalCardAmount = styled.span`
  font-weight: 700;
`

const GreyPill = styled.button`
  cursor: pointer;
  border: none;
  background: ${p => p.theme.mediumGray};
  color: #ffffff;
  font-family: ${FONT_FAMILY};
  font-weight: 600;

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`

// Vertically center the text and indicator; block removes the SVG baseline gap.
export const RiskValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  svg {
    display: block;
  }
`

export const WalkMeThroughButton = styled(GreyPill)`
  width: 100%;
  max-width: ${BOX_PAIR_MAX_WIDTH}px;
  margin-top: 8px;
  padding: 11px 35px;
  border-radius: 26px;
  font-size: 14px;
  line-height: 22px;
`
